import { render, staticRenderFns } from "./ActionPanewsPlay.vue?vue&type=template&id=342a403e&scoped=true&"
import script from "./ActionPanewsPlay.vue?vue&type=script&lang=js&"
export * from "./ActionPanewsPlay.vue?vue&type=script&lang=js&"
import style0 from "./ActionPanewsPlay.vue?vue&type=style&index=0&id=342a403e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342a403e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
